import React from 'react';
import ContentHubDetailPage from './ContentHubDetailPage';

const ResourceLibraryArticle: React.FC = () => <ContentHubDetailPage kind="resources" />;

export default ResourceLibraryArticle;
